import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { TopDestinationQuery } from '../gql/graphql';

const topDestination = graphql(/* GraphQL */ `
  query topDestination {
    topDestination {
      routeId
      routeName
      countryId
      routeImageUrl
    }
  }
`);

const useGetTopDestination = () => {
  const { data, isLoading } = useQuery<TopDestinationQuery>({
    queryKey: ['topDestination'],
    queryFn: async () => graphqlRequest<TopDestinationQuery>(topDestination), // Public endpoint, no auth needed
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    topDestination: data,
    topDestinationLoading: isLoading,
  };
};

export default useGetTopDestination;
